<template>
    <main>
        <section v-show="!dadosDeCobranca.PossuiCobrancas" class="mensagem_aviso-beneficiario u-margem-inferior-mini" tabindex="1">
            <mensagem-de-aviso :mensagem="`Não existem parcelas disponíveis para pagamento.`"
                               :tipoDeMensagem="'sucesso'" />
        </section>
        <section v-show="possuiParcelasEmAtraso & !dadosDeCobranca.ParticipaDoMorarLegal" class="mensagem_aviso-beneficiario u-margem-inferior-mini">
            <mensagem-de-aviso :mensagem="`Suas parcelas estão em atraso, selecione as parcelas abaixo e clique em
                        emitir boleto para pagamento.
                        Caso necessite de uma renegociação procure um de nossos postos de atendimento.`"
                               :tipoDeMensagem="'erro'" />
        </section>
        <section v-show="possuiParcelasEmAtraso & dadosDeCobranca.ParticipaDoMorarLegal" class="mensagem_aviso-beneficiario u-margem-inferior-mini">
            <mensagem-de-aviso :mensagem="` Ganhe 60% de desconto nos juros e multas pagando no mínimo 4 parcelas em atraso ou ganhe 100% de desconto nos juros e multas para quitar todas as parcelas em atraso.
                        Descontos previstos na Lei Nº 6.253, de 9 de Setembro de 2015 e suas alterações da campanha Morar Legal.`"
                               :tipoDeMensagem="'erro'" />
        </section>
        
        <section v-show="dadosDeCobranca.FinanciamentoEhReurbE" class="mensagem_aviso-beneficiario u-margem-inferior-mini">
            <mensagem-de-aviso :mensagem="`A seleção de parcelas só é permitida na ordem das mais antigas para as mais recentes`"
                               :tipoDeMensagem="'atencao'" />
        </section>
        <section v-show="dadosDeCobranca.FinanciamentoEstaBloqueado" class="mensagem_aviso-beneficiario mensagem_cor-aviso u-margem-inferior-grande">
            <header>
                <i class="far fa-lock-alt fa-2x u-margem-direita-mini fa_cor-erro"></i>
                <strong v-if="dadosDeCobranca.FinanciamentoEstaBloqueadoPorNotificacaoJudicial">
                    VOCÊ POSSUI PARCELAS BLOQUEADAS POR {{dadosDeCobranca.TipoDeBloqueio}}
                </strong>
                <strong v-else>
                    SEU FINANCIAMENTO ESTÁ BLOQUEADO POR {{dadosDeCobranca.TipoDeBloqueio}}
                </strong>
            </header>
            <p>
                Estas parcelas só podem ser pagas após desbloqueio e resolução do problema comunicado.
            </p>
        </section>
        <nav>
            <div class="boletos">
                <label v-if="dadosDeCobranca.CobrancasSelecionaveis.length > 0" class="formulario__input-checkbox u-margem-superior-grande">
                    <input @input="selecionarTodasAsParcelas" type="checkbox" tabindex="1" :disabled="dadosDeCobranca.PossuiDivergenciaDeRegraDePrimeiraParcela">
                    <span class="formulario__marcador" :class="!dadosDeCobranca.PossuiDivergenciaDeRegraDePrimeiraParcela ? '' : 'formulario_input-desabilitado'"></span>
                    <h3 class="titulo titulo_medio"> Selecionar todas as {{dadosDeCobranca.CobrancasSelecionaveis.length}} parcelas disponíveis</h3>
                </label>
                <div v-show="cobrancasVincendas.length > 0">
                    <h4 class="titulo titulo_pequeno u-margem-esquerda-pequena">Parcelas vincendas</h4>
                    <lista-de-cobrancas :cobrancas="cobrancasVincendas" :prazo="dadosDeCobranca.Prazo" :financiamentoEhReurbE="dadosDeCobranca.FinanciamentoEhReurbE"
                                        :podeSelecionarParcelas="true" :selecionarTodasAsParcelas="todasAsParcelasSelecionadas"
                                        :possuiDivergenciaDeRegraDePrimeiraParcela="dadosDeCobranca.PossuiDivergenciaDeRegraDePrimeiraParcela"
                                        v-model="parcelasVincendasSelecionadas" @marcarProximaParcelaSelecionavel="controlarParcelasSelecionaveis"
                                        @obterProximoNumeroDeParcelaNaOrdem ="obterProximoNumeroDeParcelaNaOrdem" />
                </div>
                <div v-show="cobrancasVencidas.length > 0">
                    <h3 class="titulo titulo_medio u-padding-inferior-media">Parcelas vencidas</h3>
                    <section v-show="!dadosDeCobranca.FinanciamentoEhReurbE" class="mensagem_aviso-beneficiario u-margem-inferior-mini">
                        <mensagem-de-aviso :mensagem="`A seleção de parcelas inadimplentes só é permitida na ordem das mais antigas para as mais recentes`"
                                        :tipoDeMensagem="'atencao'" />
                    </section>
                    <lista-de-cobrancas :cobrancas="cobrancasVencidas" :prazo="dadosDeCobranca.Prazo" :financiamentoEhReurbE="dadosDeCobranca.FinanciamentoEhReurbE"
                                        :podeSelecionarParcelas="true" :selecionarTodasAsParcelas="todasAsParcelasSelecionadas"
                                        :possuiDivergenciaDeRegraDePrimeiraParcela="dadosDeCobranca.PossuiDivergenciaDeRegraDePrimeiraParcela"
                                        v-model="parcelasVencidasSelecionadas" @marcarProximaParcelaSelecionavel="controlarParcelasSelecionaveis"
                                        @obterProximoNumeroDeParcelaNaOrdem ="obterProximoNumeroDeParcelaNaOrdem" />
                </div>
                <div v-show="dadosDeCobranca.CobrancasBloqueadas.length > 0">
                    <h4 class="titulo titulo_pequeno u-margem-esquerda-pequena">Parcelas bloqueadas</h4>
                    <lista-de-cobrancas :cobrancas="dadosDeCobranca.CobrancasBloqueadas" :prazo="dadosDeCobranca.Prazo"
                                        :podeSelecionarParcelas="false"
                                        :financiamentoEstaBloqueado="dadosDeCobranca.FinanciamentoEstaBloqueado"
                                        :selecionarTodasAsParcelas="false" @marcarProximaParcelaSelecionavel="controlarParcelasSelecionaveis"
                                        :possuiDivergenciaDeRegraDePrimeiraParcela="dadosDeCobranca.PossuiDivergenciaDeRegraDePrimeiraParcela"
                                        @obterProximoNumeroDeParcelaNaOrdem ="obterProximoNumeroDeParcelaNaOrdem" />
                </div>
            </div>
            <resumo-das-parcelas @controlaSobreposicao="mostrarSobreposicao = !mostrarSobreposicao"
                                 :parcelasSelecionadas="parcelasSelecionadas" :dadosDeNovacao="dadosDeNovacao"
                                 :totalDeParcelasAtrasadas="totalDeParcelasAtrasadas"
                                 :participaDoMorarLegal="dadosDeCobranca.ParticipaDoMorarLegal" />
        </nav>
        <div class="sobreposicao" :class="mostrarSobreposicao ? 'sobreposicao_ativo' : ''"></div>
    </main>
</template>
<script>
import ResumoDasParcelas from './resumoDasParcelas.vue';
import ListaDeCobrancas from './listaDeCobrancas.vue';
import MensagemDeAviso from './mensagemDeAviso.vue';
import utils from '../../helpers/utilsDeSelecaoDeCobrancas.js';

export default {
    name: 'conteudo',
    data() {
        return {
            mostraAba: '',
            parcelasVencidasSelecionadas: [],
            parcelasVincendasSelecionadas: [],
            todasAsParcelasSelecionadas: false,
            mostrarSobreposicao: false
        }
    },
    props: [
        'dadosDeCobranca',
        'dadosDeNovacao'
    ],
    components: {
        'resumo-das-parcelas': ResumoDasParcelas,
        'lista-de-cobrancas': ListaDeCobrancas,
        'mensagem-de-aviso': MensagemDeAviso
    },
    methods: {
        tratarPrimeiraSelecaoDeParcela() {
            this.dadosDeCobranca.CobrancasSelecionaveis.forEach(c => c.PodeSerSelecionada = false);
            const primeiraCobrancaVencida = this.dadosDeCobranca.CobrancasSelecionaveis.find(cob => cob.EstaVencida);
            const cobrancaVincenda = this.dadosDeCobranca.CobrancasSelecionaveis.find(cob => !cob.EstaVencida);
            const possuiDivergenciaDeRegra = this.dadosDeCobranca.PossuiDivergenciaDeRegraDePrimeiraParcela;

            if (primeiraCobrancaVencida)
                primeiraCobrancaVencida.PodeSerSelecionada = true;

            if (!this.dadosDeCobranca.FinanciamentoEhReurbE && cobrancaVincenda && !possuiDivergenciaDeRegra)
                cobrancaVincenda.PodeSerSelecionada = true;
        },
        selecionarTodasAsParcelas() {
            const todasEstaoSelecionadas = !this.todasAsParcelasSelecionadas
            this.todasAsParcelasSelecionadas = todasEstaoSelecionadas;

            if(!todasEstaoSelecionadas) this.tratarPrimeiraSelecaoDeParcela();
        },
        parcelaEstaVencida(cobranca) {
            const vencimentoFormatado = cobranca.VencimentoFormatado;
            const dataSeparada = vencimentoFormatado.split("/");
            const dataDoVencimento = new Date(dataSeparada[2], dataSeparada[1] - 1, dataSeparada[0]);
            const hoje = new Date();

            return hoje > dataDoVencimento;
        },
        obterProximoNumeroDeParcelaNaOrdem(numeroSelecionado) {
          const cobrancaComNumeroSelecionado = this.dadosDeCobranca.CobrancasSelecionaveis.find(c => Number(c.Parcela) === numeroSelecionado && !utils.cobrancaEstaNaValidade(c))
          const posicao = this.dadosDeCobranca.CobrancasSelecionaveis.indexOf(cobrancaComNumeroSelecionado)
          const proximaCobrancaDisponivel = this.dadosDeCobranca.CobrancasSelecionaveis[posicao + 1]
          const numeroSelecionadoEhOUltimo = posicao === this.dadosDeCobranca.CobrancasSelecionaveis.length - 1;

          return numeroSelecionadoEhOUltimo ? posicao : Number(proximaCobrancaDisponivel.Parcela)
        },
        controlarParcelasSelecionaveis() {
            const totalDeCobrancas = this.dadosDeCobranca.CobrancasSelecionaveis.length;
            const numeroDaProximaParcelaSelecionavel = this.obterProximaParcelaSelecionavel(this.parcelasSelecionadas)
            const todasAsParcelasSelecionadas = this.parcelasSelecionadas.length == this.dadosDeCobranca.CobrancasSelecionaveis.length;

            if(this.parcelasSelecionadas.length == 0) {
                this.tratarPrimeiraSelecaoDeParcela();
                return;
            } else if (todasAsParcelasSelecionadas) {
                this.dadosDeCobranca.CobrancasSelecionaveis.forEach(c => c.PodeSerSelecionada = true);
                return;
            }
            let proximasCobrancasComNumeroMaiorQueAtual = this.dadosDeCobranca.CobrancasSelecionaveis.filter(c => c.Parcela > numeroDaProximaParcelaSelecionavel);
            proximasCobrancasComNumeroMaiorQueAtual.forEach(c => c.PodeSerSelecionada = utils.cobrancaEstaNaValidade(c) && !this.dadosDeCobranca.FinanciamentoEhReurbE)

            let proximaCobrancaSelecionavel = this.dadosDeCobranca.CobrancasSelecionaveis.find(c => c.Parcela == numeroDaProximaParcelaSelecionavel);
            if(proximaCobrancaSelecionavel)
                proximaCobrancaSelecionavel.PodeSerSelecionada = true;
        },
        obterMaiorNumeroSelecionadoSemCobrancaDaValidade(numerosSelecionados, cobrancaNaValidade) {
          const numerosDasParcelasSelecionadasSemACobrancaDaValidade = numerosSelecionados.filter(n => n !== Number(cobrancaNaValidade.Parcela))
          return Math.max(...numerosDasParcelasSelecionadasSemACobrancaDaValidade)
        },
        obterProximaParcelaSelecionavel(parcelasSelecionadas) {
            const numerosDasParcelasSelecionadas = parcelasSelecionadas.map(p => Number(p.Parcela))
            const cobrancaNaValidade = this.dadosDeCobranca.CobrancasSelecionaveis.find(c => utils.cobrancaEstaNaValidade(c))
            const possuiDivergenciaDeRegra = this.dadosDeCobranca.PossuiDivergenciaDeRegraDePrimeiraParcela;
            let maiorNumeroSelecionado
            let proximoNumeroDisponivel

            if(cobrancaNaValidade)
                maiorNumeroSelecionado = this.obterMaiorNumeroSelecionadoSemCobrancaDaValidade(numerosDasParcelasSelecionadas, cobrancaNaValidade)
            else
                maiorNumeroSelecionado = Math.max(...numerosDasParcelasSelecionadas)
                      
            if(numerosDasParcelasSelecionadas.length !== 0 && !possuiDivergenciaDeRegra) {
                proximoNumeroDisponivel = this.obterProximoNumeroDeParcelaNaOrdem(maiorNumeroSelecionado)
            }
            return proximoNumeroDisponivel;
        }
    },
    watch: {
        cobrancasSelecionaveis() {
            if(this.parcelasSelecionadas.length <= 0)
                this.tratarPrimeiraSelecaoDeParcela();
        },
        parcelasVencidasSelecionadas() {
            if(this.parcelasVencidasSelecionadas.length < this.totalDeParcelasAtrasadas && this.dadosDeCobranca.FinanciamentoEhReurbE)
                this.parcelasVincendasSelecionadas = []
        }
    },
    computed: {
        possuiParcelasEmAtraso() {
            return this.dadosDeCobranca.PossuiParcelaVencida 
                    && !this.dadosDeNovacao.PossuiNovacao 
                    && this.dadosDeCobranca.CobrancasSelecionaveis.length > 0;
        },
        cobrancasVencidas() {
            return this.dadosDeCobranca.CobrancasSelecionaveis.filter(c => this.parcelaEstaVencida(c));
        },
        cobrancasVincendas() {
            return this.dadosDeCobranca.CobrancasSelecionaveis.filter(c => !this.parcelaEstaVencida(c));
        },
        parcelasSelecionadas() {
            return this.parcelasVincendasSelecionadas.concat(this.parcelasVencidasSelecionadas);
        },
        totalDeParcelasAtrasadas() {
            return this.dadosDeCobranca.CobrancasSelecionaveis.filter(c => !utils.cobrancaEstaNaValidade(c)).length
        },
        cobrancasSelecionaveis() {
            return this.dadosDeCobranca.CobrancasSelecionaveis;
        }
    }
}
</script>
